import React from 'react'
import { Link } from 'react-router-dom'
import Meses from '../../services/Meses'

export default function MesSelecionado(props) {
    const mes = Meses.filter(mes => (mes.id == props.periodo.mes_id));
    return (
        <>
            {/* <section className='container-fluid'> */}
            <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1" style={{ cursor: 'default' }}>
                <div className="card " style={{ backgroundColor: '#7F99A6' }}>
                    <div className="body text-white">
                        <h4 style={{ marginBottom: '0px' }}><i className='zmdi zmdi-calendar' style={{ fontSize: '30px' }}></i> {(mes[0]).mes}  DE {props.periodo.ano}</h4>
                        <span className='m-l-30'>PERÍODO SELECIONADO</span>
                        {/* <div className="progress m-t-20">
                                    <div className="progress-bar l-blush" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '20%' }}></div>
                                </div> */}
                        {/* <span class="text-small">TOTAL BRUTO NO ANO</span> */}
                    </div>
                </div>
            </div>

            {/* </section> */}

        </>
    )
}
